<template>
  <div class="wildlife-model">
    <section class="hero">
      <h1>North American Model of Wildlife Conservation</h1>
      <p>
        The North American Model of Wildlife Conservation is the foundation of responsible wildlife management in the United States and Canada. It ensures that wildlife is managed using science and democratic principles for the benefit of all people and future generations.
      </p>
    </section>

    <section class="principles">
      <h2>The Seven Principles</h2>
    <ul>
  <li v-for="(principle, index) in principles" :key="index">
    <div class="principle-item">
      <div class="number">{{ index + 1 }}.</div>
      <div class="text">{{ principle }}</div>
    </div>
  </li>
</ul>
    </section>
  </div>
</template>

<script>
export default {
  name: "WildlifeModel",
   data() {
    return {
      principles: [
        "Wildlife resources are conserved and held in trust for all citizens.",
        "Commerce in dead wildlife is eliminated.",
        "Wildlife is allocated according to democratic rule of law.",
        "Wildlife may only be killed for a legitimate, non-frivolous purpose.",
        "Wildlife is an international resource.",
        "Every person has an equal opportunity under the law to participate in hunting and fishing.",
        "Scientific management is the proper means for wildlife conservation.",
      ],
    };
  },
};
</script>

<style scoped>
.principles ul {
  max-width: 800px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.principles li {
  background-color: #f7f7f7;
  margin-bottom: 12px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.principle-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.number {
  width: 40px;
  text-align: left;
  font-weight: bold;
  font-size: 1.1em;
  margin-right: 10px;
}

.text {
  flex: 1;
  text-align: center;
}

.wildlife-model {
  padding: 40px 20px;
  font-family: Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

.hero {
  text-align: center;
  margin-bottom: 40px;
}

.hero h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

.hero p {
  font-size: 1.2em;
  max-width: 800px;
  margin: 0 auto;
}

.principles h2 {
  font-size: 2em;
  margin-bottom: 20px;
  text-align: center;
}

.principles ul {
  max-width: 800px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.principles li {
  background-color: #f7f7f7;
  margin-bottom: 12px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
</style>
